<template>
  <div class="menu-wrapper">
    <template v-for="item in visibleRoutes">

      <!-- If item has only one visible child -->
      <router-link v-if="hasOneVisibleChild(item.children, item)" :to="resolvePath(item, item.children[0].path)"
        :key="resolvePath(item, item.children[0].path)">
        <el-menu-item :index="resolvePath(item, item.children[0].path)">
          <span v-if="item.children[0].meta?.title">
            {{ item.children[0].meta.title }}
          </span>
        </el-menu-item>
      </router-link>

      <!-- If item has multiple children, list them all flat -->
      <template v-else>
        <router-link v-for="child in item.children" v-if="!child.hidden" :key="resolvePath(item, child.path)"
          :to="resolvePath(item, child.path)">
          <el-menu-item :index="resolvePath(item, child.path)">
            <span v-if="child.meta?.title">
              {{ child.meta.title }}
            </span>
          </el-menu-item>
        </router-link>
      </template>

    </template>
  </div>
</template>

<script>
export default {
  name: 'SidebarItem',
  props: {
    routes: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    visibleRoutes() {
      return this.routes.filter(r => !r.hidden && Array.isArray(r.children))
    }
  },
  methods: {
    hasOneVisibleChild(children = [], parent) {
      const showingChildren = children.filter(c => !c.hidden)
      return showingChildren.length === 1
    },
    resolvePath(parent, childPath) {
      if (!childPath) return parent.path
      if (parent.path === '/') return `/${childPath.replace(/^\//, '')}`
      return `${parent.path.replace(/\/$/, '')}/${childPath.replace(/^\//, '')}`
    }
  }
}
</script>
